<template>
    <div class="project-invited-column" aria-label="Project availability">
        <span class="tag is-success" data-testid="open-project-tag" v-if="openInvitation">Open</span>
        <span class="tag is-info" data-testid="invited-project-tag" v-if="value">Invited</span>
    </div>
</template>

<script setup lang="ts">

import {computed, toRefs} from "vue";

const props = withDefaults(defineProps<{
  row: any,
  value: boolean,
}>(),  {
});
const {
  row,
  value,
} = toRefs(props);

const openInvitation = computed(() => row.value.open_invitation);

</script>

<style scoped lang="scss">
    .project-invited-column {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      gap: .375rem;
      max-width: 200px;

      .tag {
        font-weight: 600;
        margin: 0;
      }
    }
</style>
